<!-- FIREBASE V9 -->
<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>
        <ProgramMemberDataComponent :uid="uid"></ProgramMemberDataComponent>

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="goToItemList">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-form ref="form" lazy-validation v-model="valid" class="ma-5 member-form">
            
            <v-layout wrap="true">
                <v-flex xs12 md2 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg2-text mr-md-3">วันที่</p>
                </v-flex>
                <v-flex xs12 md5 class="d-md-none">
                    <p class="text-subtitle-1 mr-md-3">วันที่</p>
                </v-flex>
                <v-flex xs12 md3>
                    <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :rules="requiredRule" required v-model="computedDateFormattedDate" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                        </template>
                        <v-date-picker :rules="requiredRule" v-model="editedItem.datepicker" no-title required @input="menu1 = false" :max="max" :min="min"></v-date-picker>
                    </v-menu>
                </v-flex>
            </v-layout>
            <br />
            <v-layout wrap="true">
                <v-flex xs12 md5 class="d-none d-md-inline">
                </v-flex>
                <v-flex md2 text-subtitle-1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 font-weight-bold bg-text text-center std-column">ค่ามาตรฐาน</p>
                </v-flex>
                <v-flex md2 ml-2 text-right text-subtitle-1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 font-weight-bold bg-text mr-md-7">ค่าที่วัดได้</p>
                </v-flex>
            </v-layout>
            <v-layout wrap="true" v-for="item in onsiteConfig['defaultItem']['onsite' + this.onsite]" :key="item.key">
                <v-flex md2 class="d-none d-md-inline" v-if="item.field && item.type == 'textarea'">
                    <p class="text-subtitle-1 bg2-text mr-md-3">{{ item.title }}</p>
                </v-flex>
                <v-flex md5 class="d-none d-md-inline" v-if="item.field && item.type == 'number'">
                    <p class="text-subtitle-1 bg2-text mr-md-3">{{ item.title }}</p>
                </v-flex>
                <v-flex xs12 class="d-md-none" v-if="item.field">
                    <p class="text-subtitle-1 mr-md-3">{{ item.title }}</p>
                </v-flex>
                <v-flex md5 xs12 text-subtitle-1 v-else>
                    <h3>{{ item.title }}</h3>
                </v-flex>

                <v-flex xs6 text-center text-subtitle-1 class="d-md-none" v-if="item.type == 'number'">
                    <p class="text-subtitle-1 font-weight-bold bg2-text mr-md-3">ค่ามาตรฐาน</p>
                </v-flex>

                <v-flex md4 class="d-none std-column" v-if="item.field && item.type == 'textarea'">
                    <p class="text-subtitle-1 bg2-text text-center">{{ editedItem['target'][item.field] }}</p>
                </v-flex>
                <v-flex md2 class="d-none d-md-inline std-column mr-md-2" v-if="item.field && item.type == 'number'">
                    <p class="text-subtitle-1 bg2-text text-center">{{ editedItem['target'][item.field] }}</p>
                </v-flex>
                <v-flex md5 xs6 class="d-md-none std-column" v-if="item.field && item.type == 'number'">
                    <p class="text-subtitle-1 bg2-text text-right mr-md-3 pr-3">{{ editedItem['target'][item.field] }}</p>
                </v-flex>
                <v-flex v-if="item.field != 'assignment' && item.field != 'recommendation' && item.type != 'number' && item.title != 'เพิ่มเติม'" md2 class="std-column">
                </v-flex>

                
                <v-flex xs6 text-center text-subtitle-1 class="d-md-none" v-if="item.type == 'number'">
                    <p class="text-subtitle-1 font-weight-bold bg2-text mr-md-3">ค่าที่วัดได้</p>
                </v-flex>


                <v-flex md7 class="d-none d-md-inline" v-if="item.field && item.type == 'textarea'">
                    <v-textarea outlined v-model="editedItem[item.field]" class="d-flex xs12 md4"></v-textarea>
                </v-flex>
                <v-flex xs12 class="d-md-none" v-if="item.field && item.type == 'textarea'">
                    <v-textarea outlined v-model="editedItem[item.field]" class="d-flex xs12 md4"></v-textarea>
                </v-flex>
                
                <v-flex md2 class="d-none d-md-inline" v-if="item.field && item.type == 'number'">
                    <v-text-field outlined v-model="editedItem[item.field]" class="d-flex xs12 md4" type="number" @change="calculateNumber(item.field)">
                    </v-text-field>
                </v-flex>
                <v-flex xs6 class="d-md-none" v-if="item.field && item.type == 'number'">
                    <v-text-field outlined v-model="editedItem[item.field]" class="d-flex xs12 md4" type="number" @change="calculateNumber(item.field)">
                    </v-text-field>
                </v-flex>
            </v-layout>

            <v-layout wrap="true">
                <v-flex xs12 md9 text-right>
                    <v-btn d-flex color="blue darken-1" text @click="goToItemList"> Cancel </v-btn>
                    <v-btn v-if="this.id" color="blue darken-1" text @click="submit">
                        Update
                    </v-btn>
                    <v-btn v-else color="blue darken-1" text @click="submit">
                        Add
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import getProgramInfoById from "../data/getProgramInfoById";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import setProgramInfo from '../data/setProgramInfo';
import formatData from "../utils/formatData";
import ProgramMemberDataComponent from "../components/ProgramMemberDataComponent.vue";
import {
    onsiteConfig
} from '@/helpers/onsiteConfig';
export default {
    name: 'ProgramManagementMemberForm',
    metaInfo: {
        title: 'Program Management Member Form'
    },
    components: {
        ProgramMemberDataComponent
    },
    data() {
        return {
            panel: [0,1],
            disabled: false,
            min: '',
            max: '',
            editedItem: {
                target: {},
                datepicker: '',
                weight: '',
                bmi: '',
                whr: '',
            },
            //to validate from
            valid: false,
            requiredRule: [
                (value) => !!value || "Required."
            ],
            refRule: [
                (value) => !!value || "Required.",
            ],
            dialog: false,
            title: "",
            menu1: false,
            loading: true,
            height: 0,
            showStandardColumn: true,
            onsiteConfig: onsiteConfig
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        this.id = this.$route.params.id;
        this.uid = this.$route.params.uid;
        this.onsite = this.$route.params.onsite;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin"
        ]),
        computedDateFormattedDate() {
            return this.formatDate(this.editedItem.datepicker);
        },
    },
    methods: {
        initialize() {
            if (this.isAccessCoachAdmin) {
                (async () => {
                    this.loading = true;
                    if (this.id && this.onsite) {
                        const userInfo = await getUserInfoByUserId(this.uid);
                        this.title = "Onsite #" + this.onsite + ": " + userInfo.name;
                        this.height = userInfo.height;

                        let programInfo = await getProgramInfoById(this.id, this.uid, this.onsite);
                        this.min = programInfo.startDate;
                        this.max = programInfo.endDate;
                        //set default target
                        // we want to show standard column for all
                        // if (this.onsite == 1) {
                        //     this.showStandardColumn = true;
                        // }
                        // to show same field for all onsite
                        onsiteConfig['defaultItem']['onsite' + this.onsite] = onsiteConfig['defaultItem']['onsiteForm'];

                        if (onsiteConfig['defaultItem']['onsite' + this.onsite] != undefined) {
                            for (const [key] of Object.entries(onsiteConfig['defaultItem']['onsite' + this.onsite])) {
                                if (onsiteConfig['defaultItem']['onsite' + this.onsite][key]['field'] != undefined) {
                                    this.editedItem[key] = 0;
                                    if( key == 'assignment' || key == 'recommendation' ){
                                        this.editedItem[key] = '';
                                    }
                                    //for existing record
                                    if (programInfo.onsite['onsite' + this.onsite] != undefined) {
                                        this.editedItem[key] = programInfo.onsite['onsite' + this.onsite][key] != 0 ? programInfo.onsite['onsite' + this.onsite][key] : 0;
                                        
                                        //this.editedItem['target'][key] = programInfo['target'][key] || 0;
                                    }
                                    //always get target from config(for support config updates)
                                    if (onsiteConfig['target'][key] != undefined) {
                                        if (this.editedItem['target'][key] == undefined) {
                                            if (typeof onsiteConfig['target'][key][userInfo.gender] == 'string') {
                                                this.editedItem['target'][key] = onsiteConfig['target'][key][userInfo.gender];
                                            } 
                                            else if (typeof onsiteConfig['target'][key][userInfo.gender] == 'object') {
                                                for (const [key1, value1] of Object.entries(onsiteConfig['target'][key][userInfo.gender])) {
                                                    const [startAge, endAge] = key1.split('-');
                                                    if (userInfo.age >= startAge && userInfo.age <= endAge) {
                                                        this.editedItem['target'][key] = value1;
                                                    }
                                                }
                                            }
                                        } else {
                                            this.editedItem['target'][key] = programInfo['target'][key] || 0;
                                        }
                                    }
                                }
                            }
                        }

                        //TO calculate target value for ...
                        for (const [key2] of Object.entries(this.editedItem['target'])) {
                            if (this.editedItem['target'][key2] == 'x') {
                                this.editedItem['target'][key2] = this.calculateStandard(key2);
                            }
                        }

                        if (programInfo.onsite['onsite' + this.onsite] != undefined) {
                            this.editedItem.datepicker = programInfo.onsite['onsite' + this.onsite].dateDatepicker;
                            this.editedItem.source = programInfo.onsite['onsite' + this.onsite].source;
                        }
                    }
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            if (!value) return null;
            return formatData(type, value);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        submit() {
            (async () => {
                //to validate from before submit
                await this.$refs.form.validate();
                if (this.valid && this.onsite) {
                    (async () => {
                        let programData = {
                            action: 'onsite' + this.onsite,
                            date: new Date(this.editedItem.datepicker + ' 00:00:00'),
                            program: {
                                onsite: this.onsite * 1,
                                date: new Date(this.editedItem.datepicker + ' 00:00:00'),
                                updatedDate: new Date(),
                                updatedBy: this.loggedInUserId,
                                source: {
                                    weight: this.editedItem.source != undefined ? this.editedItem.source.weight : '',
                                    fat: this.editedItem.source != undefined ? this.editedItem.source.fat : '',
                                    pressure: this.editedItem.source != undefined ? this.editedItem.source.pressure : ''
                                }
                            },
                            weight: {},
                            fat: {},
                            pressure: {}
                        };

                        for (const [key, val] of Object.entries(onsiteConfig['defaultItem']['onsite' + this.onsite])) {
                            if (val.field != undefined && this.editedItem[key] != undefined) {
                                if( val.type == 'number'){
                                    programData.program[key] = this.editedItem[key] != 0 ? this.editedItem[key] * 1 : 0;
                                }
                                else{
                                    programData.program[key] = this.editedItem[key] != 0 ? this.editedItem[key] : '';
                                }
                            }
                            if (val.field != undefined && this.editedItem.target[key] != undefined) {
                                if (programData.target == undefined) {
                                    programData.target = {};
                                }
                                if( val.type == 'number'){
                                    programData.target[key] = this.editedItem.target[key] != 0 ? this.editedItem.target[key] * 1 : 0;
                                }
                            }
                        }

                        if (this.editedItem.weight != 0) {
                            if (this.editedItem.bmi == 0) {
                                this.calculateNumber('weight');
                            }
                            programData.weight = {
                                category: 'weight',
                                weight: (this.editedItem.weight * 1),
                                height: this.height * 1,
                                bmi: this.editedItem.bmi != 0 ? (this.editedItem.bmi * 1) : 0,
                                date: new Date(this.editedItem.datepicker + ' 00:00:00'),
                                coachProgramId: this.id
                            };
                        } else {
                            programData.weight = {};
                        }
                        if (this.editedItem.waist || this.editedItem.hip) {
                            programData.fat = {
                                category: 'fat',
                                waist: this.editedItem.waist != 0 ? Number(((this.editedItem.waist * 1) / 2.54).toFixed(2)) : 0,
                                hip: this.editedItem.hip != 0 ? Number(((this.editedItem.hip * 1) / 2.54).toFixed(2)) : 0,
                                date: new Date(this.editedItem.datepicker + ' 00:00:00'),
                                coachProgramId: this.id
                            };
                            if (!programData.fat.waist) {
                                delete programData.fat.waist;
                            }
                            if (!programData.fat.hip) {
                                delete programData.fat.hip;
                            }
                        } 
                        else {
                            programData.fat = {};
                        }

                        if (this.editedItem.lowerPressure || this.editedItem.upperPressure) {
                            programData.pressure = {
                                category: 'pressure',
                                pressureLower: this.editedItem.lowerPressure != 0 ? Number(this.editedItem.lowerPressure*1) : 0,
                                pressureUpper: this.editedItem.upperPressure != 0 ? Number(this.editedItem.upperPressure*1) : 0,
                                date: new Date(this.editedItem.datepicker + ' 00:00:00'),
                                coachProgramId: this.id
                            };
                            if (!programData.pressure.lowerPressure) {
                                delete programData.pressure.lowerPressure;
                            }
                            if (!programData.pressure.upperPressure) {
                                delete programData.pressure.upperPressure;
                            }
                        } 
                        else {
                            programData.pressure = {};
                        }
                        await setProgramInfo(programData, this.id, this.uid);

                        this.dialog = true;
                    })();
                }
            })();
        },
        close() {
            this.dialog = false;
        },
        goToItemList() {
            this.$router.push(`/program/${this.$route.params.mod}/view/${this.$route.params.id}/${this.$route.params.uid}/edit`);
        },
        calculateNumber(item) {
            if (item == 'weight') {
                if (this.editedItem.weight && this.height) {
                    let bmi = (this.editedItem.weight * 10000) / (this.height * this.height);
                    this.editedItem.bmi = Number(bmi.toFixed(2));
                } else {
                    this.editedItem.bmi = '';
                }
            } else if ((item == 'waist' || item == 'hip')) {
                if (this.editedItem.waist && this.editedItem.hip) {
                    let whr = (this.editedItem.waist / this.editedItem.hip);
                    this.editedItem.whr = Number(whr.toFixed(2));
                } else {
                    this.editedItem.whr = '';
                }
            }
        },
        calculateStandard(item) {
            if (item == 'weight') {
                const weight = (23 * (this.height * this.height)) / 10000;
                return Number(weight.toFixed(2));
            } else if (item == 'hip') {
                const hip = (this.editedItem['target']['waist'] * 1) / (this.editedItem['target']['whr'] * 1);
                return Number(hip.toFixed(2));
            }

        }
    },
};
</script>

<style>
.v-textarea textarea {
    height: 70px;
}

p {
    margin-bottom: 0 !important;
}

p.bg2-text {
    line-height: 56px !important;
    text-align: left;
}

p.bg-text {
    line-height: 55px !important;
    text-align: right;
}

.member-form input[type=number] {
    text-align: right;
}

.std-column{
    background-color: #E8F5E9;
}
</style>
